import { render } from "./publicClientComponent.vue?vue&type=template&id=f836dd56&scoped=true"
import script from "./publicClientComponent.vue?vue&type=script&lang=js"
export * from "./publicClientComponent.vue?vue&type=script&lang=js"

import "./publicClientComponent.vue?vue&type=style&index=0&id=f836dd56&lang=less"
import "./publicClientComponent.vue?vue&type=style&index=1&id=f836dd56&lang=css"
import "./publicClientComponent.vue?vue&type=style&index=2&id=f836dd56&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f836dd56"]])

export default __exports__